module.exports = __webpack_public_path__ + "static/media/default_thumbnail.03c844fe.svg";